module.exports = __webpack_public_path__ + "img/list_bg1.4031349d.png";